import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import GalleryByReactApp from './components/Main';

// Render the main component into the dom
ReactDOM.render(<GalleryByReactApp />, document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.js